/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { DeleteFilled, DownloadOutlined } from '@ant-design/icons';
import { notification, Tag } from 'antd';
import dayjs from 'dayjs';
import { dateFormat } from '@/configs/dateFormat';
import { IMedia } from '@/interfaces/media';
import { deleteMedia } from '@/adapters/media';
import { IDataModal } from '@/interfaces/dataModal';
import DeleteConfirmModal from '../modal/confirm-delete';
import { mediaDownload, mediaView } from '@/utils/mediaUtils';
interface IProps {
  media: IMedia;
  onDeleted: () => void;
  readonly?: boolean;
  isDownload?: boolean;
}

const _modal: IDataModal<IMedia> = {
  open: false,
};

const MediaCard = ({ media, onDeleted, readonly, isDownload }: IProps) => {
  const [deleteModal, setDeleteModal] = useState<IDataModal<IMedia>>(_modal);
  const handleDownload = async (media: IMedia) => {
    await mediaDownload(media);
  };

  const onDeleteMedia = async () => {
    try {
      await deleteMedia(Number(deleteModal?.id));
      notification.success({
        message: 'ลบเอกสารสำเร็จ',
      });
      onDeleted();
      setDeleteModal({ ..._modal });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex bg-gray-100 rounded-md p-1 flex-row gap-2 justify-between items-center">
      <div className="flex items-center gap-2">
        <div className="bg-blue-200 p-1 m-1 rounded">
          <DocumentTextIcon className="w-8 h-8" />
        </div>
        <div>
          <div
            className="font-bold cursor-pointer"
            onClick={async () => await mediaView(media)}
          >
            {media?.name}
          </div>
          <div className="text-sm text-gray-500">
            {dayjs(media?.createDate || undefined).format(dateFormat)}
          </div>
        </div>
      </div>

      <div className="p-2 flex flex-row gap-2">
        <Tag className="font-bold px-2 py-0.5">
          {media?.mimeType?.split('/')[1]?.toUpperCase() ===
          'VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET'
            ? 'XLSX'
            : media?.mimeType?.split('/')[1]?.toUpperCase()}
        </Tag>
        {!readonly && (
          <DeleteFilled
            className="text-red-600 text-lg"
            onClick={() =>
              setDeleteModal({
                open: true,
                item: media,
                id: media.id,
              })
            }
          />
        )}
        {isDownload && (
          <DownloadOutlined
            onClick={() => handleDownload(media)}
            className="text-lg"
          />
        )}
      </div>
      <DeleteConfirmModal
        content={`คุณต้องการลบเอกสาร '${deleteModal?.item?.name}' ใช่หรือไม่`}
        handleCancel={() => {
          setDeleteModal({ ..._modal });
        }}
        handleOk={() => {
          onDeleteMedia();
        }}
        open={deleteModal?.open}
        title={`สาขา '${deleteModal?.item?.name}'`}
      />
    </div>
  );
};

export default MediaCard;
